import { Button, Tabs } from 'antd';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router';
import { PageHeader } from '../../../shared/components/PageHeader';
import { sectionTrail } from '../../../shared/components/section-trail';
import { IntegrationsSheets, type IntegrationsSheet } from '../components/IntegrationsSheets';
import { GpsSection } from '../features/gps/components/GpsSection';
import { SmsSection } from '../features/sms/components/SmsSection';
import { WhatsappSection } from '../features/whatsapp/components/WhatsappSection';
import { useIntegrationsOverview } from '../hooks/use-integrations-overview';
import { addIntegrationPath, INTEGRATION_KIND_LABELS, integrationTabPath, type IntegrationKind } from '../integrations.paths';

interface IntegrationsPageProps {
  tab: IntegrationKind;
  sheet?: IntegrationsSheet;
}

/** Integrations → a tab per kind with what is installed. The catalogue, installs and settings are sheets over the tab, each its own route. */
export function IntegrationsPage({ tab, sheet }: IntegrationsPageProps) {
  const navigate = useNavigate();
  const overview = useIntegrationsOverview();

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('integrations')}
        title="Integrations"
        description="The services Chukua uses for your company, each on your own account."
        actions={
          <Button type="primary" icon={<Plus className="size-4" />} onClick={() => navigate(addIntegrationPath(tab))}>
            Add integration
          </Button>
        }
      />
      <Tabs
        activeKey={tab}
        onChange={(key) => navigate(integrationTabPath(key as IntegrationKind))}
        items={[
          { key: 'sms', label: INTEGRATION_KIND_LABELS.sms, children: <SmsSection sms={overview.sms} /> },
          { key: 'whatsapp', label: INTEGRATION_KIND_LABELS.whatsapp, children: <WhatsappSection whatsapp={overview.whatsapp} /> },
          { key: 'gps', label: INTEGRATION_KIND_LABELS.gps, children: <GpsSection gps={overview.gps} catalogue={overview.adapters} /> },
        ]}
      />
      <IntegrationsSheets tab={tab} sheet={sheet} overview={overview} />
    </>
  );
}
